import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Header.css';
import '../index.css';

const ROUND_DURATION = 90; // seconds
const REWARD_EPOCH_DURATION = 3.5 * 24 * 60 * 60; // 3.5 days in seconds
const ANCHOR_TIMESTAMP_SONGBIRD = 1658429955;

function Header() {
  const [time, setTime] = useState(new Date());
  const [votingRound, setVotingRound] = useState(0);
  const [rewardEpoch, setRewardEpoch] = useState(0);
  const [nextEpochCountdown, setNextEpochCountdown] = useState('');
  const location = useLocation();
  
  useEffect(() => {
    const updateTimes = () => {
      const now = new Date();
      const currentTimestamp = Math.floor(now.getTime() / 1000);
      
      setTime(now);
      
      const songbirdRound = Math.floor((currentTimestamp - ANCHOR_TIMESTAMP_SONGBIRD) / ROUND_DURATION);
      setVotingRound(songbirdRound);
      
      const currentRewardEpoch = Math.floor((currentTimestamp - ANCHOR_TIMESTAMP_SONGBIRD) / REWARD_EPOCH_DURATION);
      const nextEpochStart = (currentRewardEpoch + 1) * REWARD_EPOCH_DURATION + ANCHOR_TIMESTAMP_SONGBIRD;
      const timeUntilNext = nextEpochStart - currentTimestamp;
      
      const days = Math.floor(timeUntilNext / (24 * 60 * 60));
      const hours = Math.floor((timeUntilNext % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((timeUntilNext % (60 * 60)) / 60);
      const seconds = Math.floor(timeUntilNext % 60);
      
      setRewardEpoch(currentRewardEpoch);
      setNextEpochCountdown(
        `${days}d ${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`
      );
    };
  
    updateTimes();
    const timer = setInterval(updateTimes, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatUTCTime = (date) => {
    return date.toLocaleTimeString('en-GB', { 
      timeZone: 'UTC',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <header className="header">
      <div className="clock-column">
        <div className="utc-time">
          <span className="time-value" aria-label="UTC time">{formatUTCTime(time)}</span>
        </div>
      </div>
      <div className="page-title-column">
        <h1 className="page-title">
          {location.pathname === '/nodes' && 'Node Health'}
          {location.pathname === '/fast-updates' && 'Fast Updates'}
          {location.pathname === '/ftso-submissions' && 'FTSO Submissions'}
          {location.pathname === '/ftso-performance' && 'FTSO Performance'}
          {location.pathname === '/ftso-summary' && 'FTSO Hit Rates'}
          {location.pathname === '/providers' && 'Providers'}
          {location.pathname === '/wallets' && 'Wallets'}
          {location.pathname === '/indexers' && 'INDEXERS'}
          {location.pathname === '/validators' && 'VALIDATORS'}
          {location.pathname === '/fdc-submissions' && 'FDC SUBMISSIONS'}
          {location.pathname === '/runtime-logs' && 'RUNTIME LOGS'}
          {location.pathname.startsWith('/runtime-logs/') && 'RUNTIME LOGS'}
        </h1>
      </div>
      <div className="content-column">
        <div className="info-section">
          <div className="header-info">
            <span className="header-label">Current Voting Round</span>
            <span className="header-value">{votingRound}</span>
          </div>
          <div className="divider" />
          <div className="header-info">
            <span className="header-label">Current Reward Epoch</span>
            <span className="header-value">{rewardEpoch}</span>
          </div>
          <div className="divider" />
          <div className="header-info">
            <span className="header-label">Next Epoch In</span>
            <span className="header-value">{nextEpochCountdown}</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;